import React from "react";
import SurveyMobilePreview from "../preview/SurveyMobilePreview";
import { questionTypeLabels } from "../domain/survey.constants";
import { formatDate, surveyButtonDestinationLabel, surveyTargetingStrategy } from "../domain/survey.formatters";

const SurveyOverviewWorkspace = ({ form, selectedQuestionId, onSelect }) => {
  const questions = form.questions || [];
  const selectedQuestion = questions.find((question) => question.id === selectedQuestionId);
  const targeting = surveyTargetingStrategy(form.targetingType);

  return (
    <div className="survey-builder-workspace survey-overview-workspace">
      <SurveyMobilePreview
        form={form}
        selectedQuestionId={selectedQuestionId}
        homeZoom={50}
      />

      <aside className="survey-builder-inspector survey-overview-inspector">
        <div className="survey-builder-panel-heading">
          <div><strong>Survey preview</strong><span>Review each customer-facing screen</span></div>
        </div>

        <div className="survey-builder-navigator">
          <button type="button" className={`survey-builder-nav-item home ${!selectedQuestion ? "active" : ""}`} onClick={() => onSelect("home")}>
            <span className="survey-builder-nav-number"><i className="fa fa-home" /></span>
            <span><strong>Home Card</strong><small>Survey title and description</small></span>
          </button>
          {questions.map((question, index) => (
            <button type="button" className={`survey-builder-nav-item ${selectedQuestionId === question.id ? "active" : ""}`} key={question.id} onClick={() => onSelect(question.id)}>
              <span className="survey-builder-nav-number">{index + 1}</span>
              <span className="survey-builder-nav-copy"><strong>{question.question || `Question ${index + 1}`}</strong><small>{questionTypeLabels[question.type] || question.type}</small></span>
            </button>
          ))}
          {!questions.length && <div className="survey-builder-empty">No questions added.</div>}
        </div>

        <div className="survey-overview-targeting">
          <div className="survey-builder-settings-title"><strong>Target Segmentation</strong><span>Leads eligible to receive this survey</span></div>
          <div className="survey-overview-targeting-card">
            <span className="survey-overview-targeting-number">{targeting.value}</span>
            <div><strong>{targeting.label}</strong><p>{targeting.description}</p></div>
          </div>
          <div className="survey-builder-settings-title survey-overview-reward-title"><strong>Reward</strong><span>Granted after a successful survey submission</span></div>
          <div className={`survey-overview-reward-card ${form.reward ? "enabled" : ""}`}>
            <span className="survey-overview-reward-icon"><i className={`fa ${form.reward ? "fa-gift" : "fa-minus"}`} /></span>
            <div>
              <strong>{form.reward ? `${form.reward.amount} Flash Credits` : "No reward"}</strong>
              <p>{form.reward ? "Added to the customer’s general Flash Credit balance." : "Customers complete this survey without receiving Flash Credit."}</p>
            </div>
          </div>
          <div className="survey-builder-settings-title survey-overview-action-title"><strong>Completion Button</strong><span>Shown after the customer submits the survey</span></div>
          <div className="survey-overview-action-card">
            <span className="survey-overview-action-icon"><i className="fa fa-external-link" /></span>
            <div>
              <strong>{form.buttonConfig && form.buttonConfig.label ? form.buttonConfig.label : "Not configured"}</strong>
              <p>{surveyButtonDestinationLabel(form.buttonConfig && form.buttonConfig.deepLinkUrl)}</p>
            </div>
          </div>
          <dl className="survey-overview-metadata">
            <div><dt>Status</dt><dd className="survey-overview-capitalize">{form.status || "draft"}</dd></div>
            <div><dt>Created</dt><dd>{formatDate(form.createdAt)}</dd></div>
            <div><dt>Updated</dt><dd>{formatDate(form.updatedAt)}</dd></div>
            <div><dt>Published</dt><dd>{formatDate(form.publishedAt)}</dd></div>
          </dl>
        </div>
      </aside>
    </div>
  );
};

export default SurveyOverviewWorkspace;
